import clsx from "clsx";
import { type CSSProperties, type FC, type PropsWithChildren, useRef } from "react";
import { Tooltip, useTooltip } from "widgets";
import { useResizeObserver } from "widgets/hooks";

import style from "../../styles/Cells.module.scss";

interface EllipsedContentProps {
  style?: CSSProperties;
  className?: string;
  tooltip?: string;
  isDisabled?: boolean;
}

/** @deprecated use TruncateText instead */
export const EllipsedContent: FC<PropsWithChildren<EllipsedContentProps>> = (props) => {
  const triggerRef = useRef(null);
  const tooltipRef = useRef<HTMLDivElement>(null);
  const rect = useResizeObserver(triggerRef);
  // disable tooltip in error mode, otherwise validation errors are not shown properly in edit mode
  const isDisabled = props.isDisabled || !rect?.widthOverflow;

  const { arrowProps, tooltipProps, state, triggerProps } = useTooltip(triggerRef, tooltipRef, {
    isDisabled,
    noPointerClickEvents: true,
  });

  if (!props.children) return null;

  return (
    <>
      <div
        {...triggerProps}
        ref={triggerRef}
        className={clsx(style.content_ellipsis, props.className)}
        style={props.style}
      >
        {props.children}
      </div>
      {state.isOpen && (
        <Tooltip domProps={tooltipProps} arrowProps={arrowProps} ref={tooltipRef} content={props.tooltip} />
      )}
    </>
  );
};
